module.exports = __webpack_public_path__ + "img/upWhite.702f1a43.svg";